import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorSignalService {
  showBookmarkPopupError = signal(false);
  showStartPageBanner = signal(false);
  showAppManagerBanner = signal(false);
  showAppDetailsBanner = signal(false);
  showCollectionDetailsBanner = signal(false);

  triggerCollectionDetailsBanner() {
    this.showCollectionDetailsBanner.set(true);
  }

  clearCollectionDetailsBanner() {
    this.showCollectionDetailsBanner.set(false);
  }

  triggerBookmarkError() {
    this.showBookmarkPopupError.set(true);
  }

  clearBookmarkError() {
    this.showBookmarkPopupError.set(false);
  }

  triggerStartPageBanner() {
    this.showStartPageBanner.set(true);
  }

  clearStartPageBanner() {
    this.showStartPageBanner.set(false);
  }

  triggerAppManagerBanner() {
    this.showAppManagerBanner.set(true);
  }

  clearAppManagerBanner() {
    this.showAppManagerBanner.set(false);
  }

  triggerAppDetailsBanner() {
    this.showAppDetailsBanner.set(true);
  }

  clearAppDetailsBanner() {
    this.showAppDetailsBanner.set(false);
  }
}
